export { default } from 'common/interfaces/og-metadata';
